// removed by extract-text-webpack-plugin
module.exports = {"colby-website":"_3lf4RmxM","colbyWebsite":"_3lf4RmxM","menu-bar-wrap":"_1hF5GNYo","menuBarWrap":"_1hF5GNYo","menu-bar":"aSHQYC8A","menuBar":"aSHQYC8A","content":"_3TIwxoKr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ColbyWebsite/ColbyWebsite.pcss
// module id = 1019
// module chunks = 0